import React from 'react'
import VocoContext from '../contexts/VocoContext'
import _ from '../lodash-min'
import { Formik } from 'formik'
import Container from 'react-bootstrap/Container'
import { Form } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.min.css"
import moment from 'moment'
import QuizRating from './QuizRating'
import Tooltip from "react-simple-tooltip"

export default class QuizQuestionForm extends React.Component {
    static contextType = VocoContext
    constructor(props, context) {
        super(props, context)
        let config = context.config 
        let formConfig = config.form
        let fieldsConfig = config.fields
        let formData = _.get(context.realDevice.variables, formConfig.dataPath, {})
        
        fieldsConfig.forEach(function (field) {
            if (!formData[field.name]) {
                if (field.type === "Options") {
                    let validOptions = (context.locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    formData[field.name] = field.default || context.locale.copy(field.placeholder) || validOptions[0]
                    
                } else if(field.type === "MultipleOptions") {
                    let validOptions = (context.locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    formData[field.name] = {}
                    validOptions.forEach(function(name) {
                        formData[field.name][name] = false
                    })
                    
                } else if (field.type === "RadioOption") {
                    let validOptions = (context.locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    formData[field.name] = field.default || context.locale.copy(field.placeholder) || validOptions[0]
                } else {
                    formData[field.name] = field.default || ""
                }
            }
        })
        
        this.state = {
            formData : formData,
            values: formData,
            formSubmissionError: false,
            formSubmissionData: this.context.realDevice.variables?.['quizQuestionForm']?.singleSubmissions?.[formConfig.dataPath],
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.validate = this.validate.bind(this)
        this.buildPackageStatus = this.buildPackageStatus.bind(this)
    }
    
    componentDidMount(){
        if(this.context.parent?.container) {
            this.context.el.threeRadicalForm = { 
                status : async function () {
                    return this.buildPackageStatus(null, this.validate(this.state.values, this.state.props))
                }
            }
            
            this.context.el.threeRadicalForm.status = this.context.el.threeRadicalForm.status.bind(this)
        }
    }
    
    buildPackageStatus(values, errors) {
        if(!errors){
            errors = {}
        }
        
        return {
          canSubmit: !Object.keys(errors).length,
          value: values || this.state.values,
          validation: !Object.keys(errors).length ? [] : ["Some field answers are incorrect/incomplete"]
        }
    }
    
    sendPackageStatus(values, errors) {
        if((this.context.parent || {}).form) {
            let eventDetails = this.buildPackageStatus(values, errors)
            console.log("  -> " + (this.context.modules.fieldName || "") + " - Sending state to parent form: ", JSON.stringify(eventDetails))
            this.context.el.dispatchEvent(new CustomEvent("threeRadical.form.state", { detail: eventDetails }))
        }
    }
    
    async onSubmit(formData, { setSubmitting }, isNotFinal) {
        let realDevice = this.context.realDevice
        let device = this.context.device
        let formConfig = this.context.config.form || {}
        
        let fieldsConfig = this.context.config.fields || []
        let locale = this.context.locale
        
        if(formConfig.webService){
            console.log("/web-service/" + realDevice.schemeId + "/" + formConfig.webService)
            try {
                let optionalyFormData = await realDevice.gtp("/web-service/" + realDevice.schemeId + "/" + formConfig.webService, formData, "POST")
                if (optionalyFormData) {
                    formData = optionalyFormData
                }
                if (
                    Object.keys(optionalyFormData).length !== 0 ||
                    optionalyFormData === false
                  ) {
                    this.setState({
                      formSubmissionError: false,
                      formSubmissionData: true
                    })
                  } else {
                    this.setState({ formSubmissionError: true })
                  }
                  setSubmitting(false)
                } catch (e) {
                this.setState({ formSubmissionError: true })
                console.warn(e, e.stack) 
                setSubmitting(false)
                console.log("Trigger Outcome - Invalid")
                return device.triggerOutcome("Invalid")
            }
        }
        
        fieldsConfig.forEach(function (field){
            if (field.type === "Options") {
                if (formData[field.name]) {
                    if(!field.PII){
                        realDevice.queueUnlock("Quiz.form.option",field.name + "=" + formData[field.name]) 
                    }
                    realDevice.queueUnlock("Quiz.form.validField", field.name)
                } else {
                    if(!field.PII){
                        realDevice.queueUnlock("Quiz.form.emptyOption",field.name + "=" + formData[field.name]) 
                    }
                    realDevice.queueUnlock("Quiz.form.emptyField", field.name)
                }
            } else if (field.type === "MultipleOptions" && formData[field.name]) {
                let validOptions = (locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                let optionCount = 0
                if(!field.PII){
                    validOptions.forEach(function(option, index){
                        /* Due to some terrible life choices by someone a very long time ago the type
                         * of variables in the Device.variables gravitates towards strings. */
                        if (formData[field.name][option] && formData[field.name][option] !== "false") {
                            realDevice.queueUnlock("Quiz.form.multiOption",field.name + "=" + option)
                            realDevice.queueUnlock("Quiz.form.multiOptionIndex",field.name + "=" + index)
                            optionCount++
                        } else {
                            realDevice.queueUnlock("Quiz.form.emptyMultiOption",field.name + "=" + option)
                            realDevice.queueUnlock("Quiz.form.emptyMultiOptionIndex",field.name + "=" + index)
                        }
                    })
                }
                
                if (optionCount) {
                   realDevice.queueUnlock("Quiz.form.validField", field.name) 
                } else {
                   realDevice.queueUnlock("Quiz.form.emptyField", field.name) 
                }
                
            }  else if (field.type === "RadioOption") {
                if (formData[field.name]) {
                    if(!field.PII){
                        realDevice.queueUnlock("Quiz.form.radioOption",field.name + "=" + formData[field.name]) 
                    }
                    realDevice.queueUnlock("Quiz.form.validField", field.name)
                } else {
                    //if(!field.PII){
                    //    realDevice.queueUnlock("Quiz.form.emptyRadioOption",field.name + "=" + formData[field.name]) 
                    //}
                    //realDevice.queueUnlock("Quiz.form.emptyField", field.name)
                }
            } else {
                if (formData[field.name]) {
                   realDevice.queueUnlock("Quiz.form.validField", field.name) 
                } else {
                   realDevice.queueUnlock("Quiz.form.emptyField", field.name) 
                }
            }
        })  
        
        let unlockObject = {}
        
        fieldsConfig.forEach(function (field){
            switch(field.type) {
                case "Email": /* Unlocks should not contain PII */
                    break;
                default:
                    unlockObject[field.name] = formData[field.name]
                    break;
            }
        })

        let currentData = _.get(this.context.realDevice.variables, formConfig.dataPath, {});
        
        if('Multiple' === formData.recordStyle) {
            if(!Array.isArray(currentData)) {
                if(currentData) {
                    currentData = [currentData];
                } else {
                    currentData = [];
                }
            }
            currentData.unshift(formData);
        } else {
            currentData = formData;
        }

        realDevice.queueUnlock("Quiz.form.submit", JSON.stringify(unlockObject));

        await realDevice.canUpdateData();
        let variables = realDevice.variables || {};
        _.set(variables, formConfig.dataPath, currentData);
        _.set(variables, ["quizQuestionForm", "singleSubmissions", formConfig.dataPath], Date.now());
        
        for(let i = 0; i < this.context.config.fields.length; i++) {
            let field = this.context.config.fields[i]
            if(field.type === "MultipleOptions") {
                _.set(
                    variables, 
                    formConfig.dataPath + "." + field.name + "_Array", 
                    Object.keys(currentData[field.name]).reduce(function(mem, cur){
                        if(currentData[field.name][cur]){
                            mem.push(cur)
                        }
                        return mem
                    }, [])
                );
            }
        }
        
        this.setState({
          formSubmissionData: true
        })

        realDevice.variables = variables

        console.log("Trigger Outcome - Valid")
        return device.triggerOutcome("Valid", !isNotFinal)
    }
    
    onCancel() {
        return this.context.device.triggerOutcome("Cancel", true)
    }
    
    validate(values, props) {
        if(!this.state.hasClickedSubmit) {
            return undefined
        }
        let fieldsConfig = this.context.config.fields || [] 
        let formConfig = this.context.config.form || {}
        let errors = {}
        let numerals = "0123456789".split('')
        let conditions = []
        let locale = this.context.locale
        let parent = this.context.parent || {}
        
        fieldsConfig.forEach(function (fieldConfig){
            switch(fieldConfig.type) {
                case "Rating":
                    return
                case "Date": 
                    return
                case "MultipleOptions":
                    let keys = Object.keys(values[fieldConfig.name])
                    if(fieldConfig.forceAnswer) {
                        let pass = false
                        for(let i = 0; i < keys.length; i++) {
                            if(values[fieldConfig.name][keys[i]]) {
                                pass = true
                            }
                        }
                        
                        if(!pass) {
                            errors[fieldConfig.name] = true
                        }
                    }
                    
                    return
                case "RadioOption":
                    conditions = (locale.copy(fieldConfig.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    if(fieldConfig.forceAnswer && conditions.indexOf(values[fieldConfig.name]) === -1) {
                        errors[fieldConfig.name] = true
                    }
                    return
                case "Options":
                    conditions = (locale.copy(fieldConfig.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    if(!conditions.includes(values[fieldConfig.name])) {
                        errors[fieldConfig.name] = true
                    } else {
                        return
                    }
                    
                    return
                case "Numeric":
                    conditions = validationToArray(locale.copy(fieldConfig.validation))
                    
                    if (conditions.length < 1) {
                        return
                    }
                    
                    if (conditions.some(matchNumericConditions.bind(null, values[fieldConfig.name]))) {
                        return
                    } else {
                        errors[fieldConfig.name] = true
                    }
                    
                    return
                case "Email":
                    conditions = validationToArray(locale.copy(fieldConfig.validation))
                    
                    if (conditions[0] && conditions[0] === "@") {
                        if (values[fieldConfig.name].indexOf('@') < 1) {
                            errors[fieldConfig.name] = true
                            return
                        }
                        conditions = conditions.slice(1)
                    }
                    
                    if (conditions.length < 1) {
                        return
                    }
                    
                    if (conditions.some(matchEmailConditions.bind(null, values[fieldConfig.name]))) {
                        return
                    } else {
                        errors[fieldConfig.name] = `Email must consist ${conditions}`
                    }
                    
                    return
                default:
                    conditions = validationToArray(locale.copy(fieldConfig.validation))
                    
                    if (conditions.length < 1) {
                        return
                    }
                    
                    if (conditions.some(matchTextConditions.bind(null, values[fieldConfig.name]))) {
                        return
                    } else {
                        errors[fieldConfig.name] = conditions.length ? `${locale.copy(fieldConfig.label)}  ${locale.copy(fieldConfig.help)}` : ''
                    }
                    
                    return
            }
        })
        
        let errorCount = Object.keys(errors).length
        let errorList = []
        
        if (this.errorCount !== errorCount) {
            if (errorCount) {
                for(let e in errors){
                    errorList.push(e)
                    // toast.warn(`${e} is invalid`);
                }
                this.setState({errorList})
            } else {
                console.log(formConfig.dataPath, "Validation Pass")
                this.setState({errorList: []})
            }
            
            this.errorCount = errorCount
        }
        
        if(parent.form){
            this.sendPackageStatus(values, errors)    
        }
        
        this.setState({ values: values }) 
        return Object.keys(errors).length ? errors : undefined
        
        function matchEmailConditions(textValue, cond) {
            if (typeof cond.test === "function") {
                return cond.test(textValue)
            } else if (cond && cond.substr(0,1) === "@"){
                return (textValue.split('@')[1] || "") === cond.substr(1)
            } else {
                return textValue === cond
            }
        }
        
        function matchTextConditions(textValue, cond) {
            if (typeof cond.test === "function") {
                return cond.test(textValue)
            } else {
                return textValue === cond
            }
        }
        
        function matchNumericConditions(textValue, cond) {
            let chars = textValue.split("")
            
            if (typeof cond.test === "function") {
                return cond.test(textValue)
            } else{
                let validChars = numerals.concat(cond.split(""))
                return chars.every(c => validChars.indexOf(c) >= 0)
            }
        }
        
        function validationToArray(validation){
            return validation 
                .trim()
                .split(/\r?\n/)
                .map(s => s.trim())
                .filter(Boolean)
                .map(function (cond){
                    if (cond.indexOf("/") === 0) {
                        let endReg = cond.lastIndexOf("/")
                        let regSource = cond.substr(1,endReg - 1)
                        let regFlags = cond.substr(endReg + 1)
                        return new RegExp(regSource, regFlags)
                    } else {
                        return cond
                    }
                })
        }
    }
    
    render() {
        let locale = this.context.locale
        let formConfig = this.context.config.form || {}
        let fieldsConfig = this.context.config.fields || []
        let override = this.context.config.override || {}
        let message = this.context.message || {}
        let parent = this.context.parent || {}
        
        let ioc = this.context.ioc
        let buttons = message.quantities.buttons
        let device = this.context.device
        
        let embedContent = ioc.injectWithModules(["3r/message-api/content/embedMessageContent"], function(embedMessageContent, text){
            return embedMessageContent(message, {}, text)     
        })
        
        let cancelActions = this.context?.config?.form?.listOfCancelActions?.split("\n")
        let title = locale.copy(override.title) || embedContent(message.title)
        let titleElement = override.titleDisplay
        let markedUp = locale.copy(override.message) || ioc.run("3r/message-api/content/embedMessageContent", message)
        let image = locale.copy(override.image) || ( (message.offerImage && message.offerImage !== "undefined.jpg") ? message.offerImage : "" )
        let footer = ["<p><br></p>", "<p></p>"].indexOf(locale.copy(override.footer)) === -1 ? locale.copy(override.footer) : message.footer
        let outro = ["<p><br></p>", "<p></p>"].indexOf(locale.copy(formConfig.outro)) === -1 ? (locale.copy(formConfig.outro) || '') : ''
        
        let errorList = this.state.errorList
        let onCancel = this.onCancel.bind(this)
        let showFormAfterSingleSubmission = !this.state.formSubmissionData || !formConfig.singleSubmission
        let that = this
        
        const press = ioc.injectWithModules(["3r/message-api/helpers/press"], function(press, buttonIndex,buttonValue) {
            let button = buttons[buttonIndex]
            
            if (cancelActions.includes(buttonValue)) {
                device.triggerOutcome("Cancel")
                if (!button.close) {
                    device.triggerOutcome(button.value)
                }
                return press(
                    null,
                    function () {
                            return device.triggerOutcome(button.value, true)
                    },
                    message,
                    button
                )
            }else{
                return press(
                    null,
                    function () {
                        return device.triggerOutcome(button.value, true)
                    },
                    message,
                    button
                )   
            }
        })
        
        const cancelFlow = async(button) => {
            await onCancel()
            press(button.index,button.value)
        }
        
        const submitFlow = async(values, setSubmitting, button) => {
            this.setState({
                hasClickedSubmit: true
            }, async () => {
                const error = this.validate(values,null)
                if(!error){
                    await this.onSubmit(values, {setSubmitting}, !!button)
                    
                    if(button) {
                        return press(button.index,button.value) 
                    } else {   
                        return true   
                    }
                }
            })
        }
        
        const camelize = (str) => {
          return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
          }).replace(/\s+/g, '');
        }
        
        let buildFormControl = (values, locale, formConfig, handleBlur, handleChange, setFieldValue, touched, errors, field, i) => {
            let validOptions = []
            let fieldName = camelize(field.name)
            let fieldNameLegacy = field.name.replace(/\s+/g,"-")
            let formControl,
                tooltip = {
                    errorHandling: formConfig.tooltipErrorHandling
                }
            
            switch(field.type) {
                case "Numeric":
                    formControl = <Form.Control 
                        type="text"
                        name={field.name}
                        className={"wf-tactic-quiz-form-field-inputText wf-tactic-quiz-form-inputText wf-tactic-quiz-inputText wf-tactic-inputText wf-inputText"}
                        placeholder={locale.copy(field.placeholder)}
                        value={values[field.name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={(touched[field.name] && errors[field.name]) || errorList?.includes(field.name)}
                    />
                    
                    Object.assign(tooltip, {
                        classes: [(values[field.name] ? (errors[field.name]  ? "customTooltipAfter" : 'customTooltipBefore') :  (locale.copy(field.help) ? 'customTooltipAfter' : 'customTooltipBefore'))]
                    })
                    
                    break;
                case "Options":
                    validOptions = (locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    let selectedOption = values[field.name] ? values[field.name] : locale.copy(field.placeholder)
                    formControl = <Form.Control 
                            as="select" 
                            name={field.name}
                            className={"wf-tactic-quiz-form-field-select wf-tactic-quiz-form-select wf-tactic-quiz-select wf-tactic-select wf-select"}
                            placeholder={locale.copy(field.placeholder)}
                            value={values[field.name]}
                            onChange={handleChange}
                            selected={selectedOption}
                            onBlur={handleBlur}
                            isInvalid={(touched[field.name] && errors[field.name]) || errorList?.includes(field.name)}
                        >
                            {locale.copy(field.placeholder) ? <option className={"wf-tactic-quiz-form-field-select-optionPlaceholder wf-tactic-quiz-form-field-optionPlaceholder wf-tactic-quiz-form-optionPlaceholder wf-tactic-quiz-optionPlaceholder wf-tactic-optionPlaceholder wf-optionPlaceholder"} key={locale.copy(field.placeholder)}>{locale.copy(field.placeholder)}</option> : '' }
                                {validOptions.map(function (val, j){
                                    return <option className={"wf-tactic-quiz-form-field-select-option-" + i + "-" + j + " wf-tactic-quiz-form-field-select-option wf-tactic-quiz-form-field-option wf-tactic-quiz-form-option wf-tactic-quiz-option wf-tactic-option wf-option"} key={val}>{val}</option>
                                })}
                         </Form.Control>
                    
                    Object.assign(tooltip, {
                        classes: [(values[field.name] ? (errors[field.name]  ? "customTooltipAfter" : 'customTooltipBefore') : 'customTooltipAfter')]
                    })
                    
                    break;
                case "MultipleOptions":
                    validOptions = (locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    tooltip.errorHandling = false
                    formControl = validOptions.map(function (val, j){
                        let optionId = (message.id + field.name + "-" + val).replace(/\s+/g,"-")
                        return <Form.Check 
                            id={optionId}
                            label={val}
                            className={"wf-tactic-quiz-form-field-mOptions-option-" + i + "-" + j + " wf-tactic-quiz-form-field-mOptions-option wf-tactic-quiz-form-field-option wf-tactic-quiz-form-option wf-tactic-quiz-option wf-tactic-option wf-option"}
                            type="checkbox"
                            name={field.name + '[' + val + ']'}
                            checked={values[field.name][val]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            key={val}
                        />
                    })
                    
                    Object.assign(tooltip, {
                        errorHandling: false,
                        classes: []
                    })
                    
                    break;
                case "Email":
                    formControl = <Form.Control 
                        type="email"
                        name={field.name}
                        className={"wf-tactic-quiz-form-field-email wf-tactic-quiz-form-email wf-tactic-quiz-email wf-tactic-email wf-email"}
                        placeholder={locale.copy(field.placeholder)}
                        value={values[field.name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={(touched[field.name] && errors[field.name]) || errorList?.includes(field.name)}
                    />
                    
                    Object.assign(tooltip, {
                        content: values[field.name] ? (errors[field.name] ? errors[field.name] : '') : locale.copy(field.help), //NANI?
                        classes: [(values[field.name] ? (errors[field.name]  ? "customTooltipAfter" : 'customTooltipBefore') :  (locale.copy(field.help) ? 'customTooltipAfter' : 'customTooltipBefore'))]
                    })
                    
                    break;
                case "Date":
                    formControl = <DatePicker 
                        name={field.name}
                        onBlur={handleBlur}
                        selected={values[field.name] ? moment(values[field.name], 'YYYY-MM-DD').toDate() : null}
                        onChange={date => { 
                            if(date) {
                                setFieldValue(`${field.name}`, moment(date).format('YYYY-MM-DD'))
                            } else {
                                setFieldValue(`${field.name}`, null)
                            }
                        }}      
                        format="MM/DD/YYYY"         
                        className={"wf-tactic-quiz-form-field-datepicker wf-tactic-quiz-form-datepicker wf-tactic-quiz-datepicker wf-tactic-datepicker wf-datepicker form-control"}     
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        autoComplete="off"                
                    />
                    
                    Object.assign(tooltip, {
                        classes: ["customTooltipAfter"],
                        maxContentWrapper: true
                    })
                    
                    break;
                case "Rating":
                    validOptions = locale.copy(field.validation) || 5
                    formControl = <QuizRating 
                        field={field}
                        value={values[field.name]} 
                        onChange={rating => {
                            values[field.name] = rating
                            this.validate(values, this.state.props)
                        }}
                        outOf={validOptions}
                    />
                    
                    Object.assign(tooltip, {
                        maxContentWrapper: true,
                        classes: ["customTooltipAfter"]
                    })
                    
                    break;
                case "RadioOption" :
                    validOptions = (locale.copy(field.validation) || "").trim().split(/\r?\n/).filter(Boolean)
                    let selectedRadioOption = values[field.name] ? values[field.name] : locale.copy(field.placeholder)
                    formControl = validOptions.map(function (val, j){
                        return (
                            <div style={{'display' : 'flex', 'flexDirection' : 'row'}} 
                                className={"wf-tactic-quiz-form-field-radioOption-"+i+"-"+j + " wf-tactic-quiz-form-field-radioOption wf-tactic-quiz-form-radioOption wf-tactic-quiz-radioOption wf-tactic-radioOption wf-radioOption"}
                                key={"wf-tactic-quiz-form-radioOption-"+i+"-"+j}>
                                <Form.Control 
                                    type="radio" 
                                    name={field.name}
                                    placeholder={locale.copy(field.placeholder)}
                                    value={val}
                                    onChange={handleChange}
                                    checked={selectedRadioOption === val ? true : false}
                                    onBlur={handleBlur}
                                    style={{'width' : '20px'}}
                                /> 
                                <label>&nbsp;{val}</label>
                            </div>
                        )
                    })
                    
                    Object.assign(tooltip, {
                        maxContentWrapper: true,
                        classes: ["customTooltipAfter"]
                    })
                    
                    break;
                case "TextArea":
                    formControl = <Form.Control 
                        as="textarea"
                        type="text"
                        rows={3}
                        name={field.name}
                        className = {"wf-tactic-quiz-form-field-inputTextArea wf-tactic-quiz-form-inputTextArea wf-tactic-quiz-inputTextArea wf-tactic-inputTextArea wf-inputTextArea"}
                        placeholder={locale.copy(field.placeholder)}
                        value={values[field.name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={(touched[field.name] && errors[field.name]) || errorList?.includes(field.name)}
                    />
                    
                    Object.assign(tooltip, {
                        content: values[field.name] ? (errors[field.name] ? errors[field.name] : '') : locale.copy(field.help),
                        classes: [(values[field.name] ? (errors[field.name]  ? "customTooltipAfter" : 'customTooltipBefore') : (locale.copy(field.help) ? 'customTooltipAfter' : 'customTooltipBefore'))]
                    })
                    
                    break;
                default:
                    formControl = <Form.Control 
                        type="text"
                        name={field.name}
                        className = {"wf-tactic-quiz-form-field-inputText wf-tactic-quiz-form-inputText wf-tactic-quiz-inputText wf-tactic-inputText wf-inputText"}
                        placeholder={locale.copy(field.placeholder)}
                        value={values[field.name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={(touched[field.name] && errors[field.name]) || errorList?.includes(field.name)}
                    />
                    
                    Object.assign(tooltip, {
                        content: values[field.name] ? (errors[field.name] ? errors[field.name] : '') : locale.copy(field.help),
                        classes: [(values[field.name] ? (errors[field.name]  ? "customTooltipAfter" : 'customTooltipBefore') : (locale.copy(field.help) ? 'customTooltipAfter' : 'customTooltipBefore'))]
                    })
                    
                    break;
            }
            
            if(tooltip.errorHandling) {
                formControl = <Tooltip 
                    content={tooltip.content || locale.copy(field.help)} //DPB-1071 - field.help now html type so will need to find way to implement changes here
                    className={"wf-tactic-quiz-form-field-tooltip wf-tactic-quiz-form-tooltip wf-tactic-quiz-tooltip wf-tactic-tooltip wf-tooltip " + (tooltip.classes || []).join(" ")}
                    background={tooltip.background || formConfig.tooltipBackground}
                    border={tooltip.borderColor || formConfig.tooltipBorderColor}
                >
                    {formControl}
                </Tooltip>
                
                if(tooltip.maxContentWrapper) {
                    formControl = <div style={{width : 'max-content'}}>
                        {formControl}
                    </div>
                }
            } else if (!formConfig.helpMessageInValidation) { 
                formControl = <>
                    {formControl}
                    {locale.copy(field.help) && <Form.Text className={"wf-tactic-quiz-form-field-help wf-tactic-quiz-form-help wf-tactic-quiz-help wf-tactic-help wf-help"}>
                        <div dangerouslySetInnerHTML={{__html: locale.copy(field.help)}}></div>
                    </Form.Text> }
                </>
            }
            
            formControl = <Form.Group key={field.name} className={"wf-tactic-quiz-form-field-" + i + " wf-tactic-quiz-form-field_" + fieldName + " wf-tactic-quiz-form-field wf-tactic-quiz-field wf-tactic-field wf-field quiz-question-form-" + fieldNameLegacy}>
                <Form.Label className="wf-label">
                    <div dangerouslySetInnerHTML={{__html: locale.copy(field.label)}}></div>
                </Form.Label>
                {formControl}
            </Form.Group>
                    
            return formControl
        }
        
        return <Container id={"quizQuestionFormPackage" + message.systemId} className={"wf-tactic-quiz-form wf-tactic-quiz wf-tactic quizQuestionForm"}>
            { !parent.form && titleElement && React.createElement(titleElement, { className: 'wf-tactic-quiz-form-title wf-tactic-quiz-title wf-tactic-title wf-title' }, title) }
            { !parent.form && image &&  <div className="wf-tactic-quiz-form-offerImageBox wf-tactic-quiz-offerImageBox wf-tactic-offerImageBox wf-offerImageBox">
                    <img className="wf-tactic-quiz-form-offerImage wf-tactic-quiz-offerImage wf-tactic-offerImage wf-offerImage" alt="quiz-question-form-banner" src={image}/>
                </div>
            }
            { !parent.form && markedUp && 
                <p className="wf-tactic-quiz-form-message wf-tactic-quiz-message wf-tactic-message wf-message" dangerouslySetInnerHTML={{__html: markedUp}}></p>
            }
            <Formik
                initialValues={this.state.formData}
                onSubmit={''}
                validate={!buttons.length ? this.validate : ''} 
            >
                {
                    function ({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setSubmitting, setFieldValue}) {
                        return <Form className={"wf-tactic-quiz-form wf-tactic-form wf-form"} inline={formConfig.style === "Inline"} onSubmit={handleSubmit}>
                            { showFormAfterSingleSubmission && fieldsConfig.map(buildFormControl.bind(this, values, locale, formConfig, handleBlur, handleChange, setFieldValue, touched, errors))}
                            
                            { !parent.form && outro && showFormAfterSingleSubmission && <p dangerouslySetInnerHTML={{__html: outro}} /> }
                            
                            {
                                !formConfig.tooltipErrorHandling &&
                                    <div className="wf-validation validation-container">
                                        {formConfig.validationMessage && !formConfig.helpMessageInValidation && errorList && errorList.length ? <div>
                                            <h5 className="wf-validation-title validation-title">{formConfig.validationMessage}</h5>
                                            {errorList.map((o, i) => (
                                                <li key={i} className="wf-validation-error validation-list">{o} is invalid</li>
                                            ))}
                                        </div>: null}
                                        {formConfig.validationMessage && formConfig.helpMessageInValidation && errorList && errorList.length ? <div>
                                            <h5 className="wf-validation-title validation-title">{formConfig.validationMessage}</h5>
                                            {fieldsConfig.filter(f => {
                                                    return errorList.indexOf(f.name) !== -1
                                                }).map((o, i) => (
                                                    <li key={i} className="wf-validation-error validation-list" dangerouslySetInnerHTML={{__html: locale.copy(o.help)}}></li>
                                                ))
                                            }
                                        </div>: null}
                                    </div>
                            }
                            
                            { !parent.form && showFormAfterSingleSubmission && !buttons.length && 
                                <div className={"wf-tactic-quiz-form-actions wf-tactic-quiz-actions wf-tactic-actions wf-actions"}>
                                    <button 
                                        type="button" 
                                        className={
                                            "wf-tactic-quiz-form-submit-0 wf-tactic-quiz-form-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit " + 
                                            "wf-tactic-quiz-form-button wf-tactic-quiz-button wf-tactic-button wf-button " + formConfig.submitClassName
                                        } 
                                        disabled={isSubmitting}
                                        onClick={()=>submitFlow(values, setSubmitting, null)} 
                                    >
                                        {locale.copy(formConfig.submit)}
                                    </button>
                                    { formConfig.cancel && <button type="button" className={"wf-tactic-quiz-form-cancel-1 wf-tactic-quiz-form-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel wf-tactic-quiz-button wf-tactic-button wf-button " + formConfig.cancelClassName} onClick={onCancel}>{locale.copy(formConfig.cancel)}</button> }
                                </div>
                            }
                            
                            { !parent.form && formConfig.submitting && isSubmitting && (
                                <div className="wf-submitMessage alert alert-primary" role="alert">
                                    {formConfig.submitting}
                                </div>
                            )}
                            
                            { !parent.form && formConfig.submissionError && that.state.formSubmissionError && (
                                <div className="wf-errorMessage alert alert-danger" role="alert">
                                    {formConfig.submissionError}
                                </div>
                            )}
                            
                            { !parent.form && formConfig.submitted && !isSubmitting && that.state.formSubmissionData && (
                                <div className="wf-submittedMessage alert alert-success" role="alert">
                                    {formConfig.submitted}
                                </div>
                            )}
                            
                            { !parent.form && !!buttons.length && <div className={"wf-tactic-quiz-form-actions wf-tactic-quiz-actions wf-tactic-actions wf-actions"}>
                                {
                                    buttons.map((button, i) => 
                                        button.type === 'hyperlink' ? 
                                            <a href={button.hyperlink.url} rel="" target={button.hyperlink.target}>
                                                {
                                                    cancelActions.includes(button.value) ?
                                                        <button type="button" className={"wf-tactic-quiz-form-cancel-" + i + " wf-tactic-quiz-form-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel btn btn-primary"} style={{margin: "10px"}} onClick={()=>cancelFlow(button)} key={button.value}>
                                                            {embedContent(button.caption)}
                                                        </button>
                                                    :
                                                        <button type="button" className={"wf-tactic-quiz-form-submit-" + i + " wf-tactic-quiz-form-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary"} style={{margin: "10px"}} onClick={()=>submitFlow(values, setSubmitting, button)} key={button.value}>
                                                            {embedContent(button.caption)}
                                                        </button>
                                                }
                                              
                                            </a>
                                        : 
                                            cancelActions.includes(button.value) ?
                                                <button type="button" className={"wf-tactic-quiz-form-cancel-" + i + " wf-tactic-quiz-form-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel btn btn-primary"} style={{margin: "5px"}} onClick={()=>cancelFlow(button)} key={button.value}>{embedContent(button.caption)}</button>
                                            :
                                                <button type="button" className={"wf-tactic-quiz-form-submit-" + i + " wf-tactic-quiz-form-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary"} style={{margin: "5px"}} onClick={()=>submitFlow(values, setSubmitting, button)} key={button.value}>{embedContent(button.caption)}</button>
                                    )
                                }
                            </div>}
                            
                            { !parent.form && footer && <footer><center><small><span dangerouslySetInnerHTML={{__html: footer}}></span></small></center></footer> }
                        </Form>
                    }
                }
            </Formik>
        </Container>
    }
}